/*//////////////////////*/
/* Exports
/*/ /////////////////////*/

export const getProgrammeReducer = (state) => state.programme;
